export const FIND_LESION_BY_ID_COMPLETED = "project/lesion/findLesionByIdCompleted";
export const FIND_ALL_LESION_COMPLETED = "project/lesion/findAllLesionCompleted";
export const FIND_LESION_BY_TYPE_COMPLETED = "project/lesion/findLesionByTypeCompleted";
export const FIND_LESION_BY_PLAYER_COMPLETED = "project/lesion/findLesionByPlayerCompleted";
export const ADD_LESION_COMPLETED = "project/lesion/addLesionCompleted";
export const ADD_LESION_TO_PLAYER_COMPLETED = "project/lesion/addLesionToPlayerCompleted";
export const UPDATE_LESION_COMPLETED = "project/lesion/updateLesionCompleted";
export const REMOVE_LESION_COMPLETED = "project/lesion/removeLesionCompleted";
export const REMOVE_LESION_TO_PLAYER_COMPLETED = "project/lesion/removeLesionToPLayerCompleted";
export const CLEAR_LESION_SEARCH = "project/lesion/clearLesionSearch";
export const FIND_ALL_LESION_PAGE_COMPLETED = "project/lesion/findAllLesionPageCompleted";
export const FIND_LESION_BY_TYPE_PAGE_COMPLETED = "project/lesion/findLesionByTypePageCompleted";